// @flow

import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { combineEpics, ofType } from 'redux-observable';

import type { ActionsObservable, StateObservable, Middleware } from '../common/typings';
import bugsnag from '../bugsnag';
import SlingStorage from '../common/SlingStorage';
import { STORAGE_GUID_FIELD, STORAGE_TIME_FORMAT_FIELD, STORAGE_SESSION_FIELD } from '../constants';
import { addErrorToast } from '../utils/actions';
import { scheduleRedirection, initializeSuccess } from '../core/actions';

import { LOG_IN, INTEGRATION_LOG_IN, logInSuccess, logInExternalUser } from './actions';

const { bugsnagClient } = bugsnag;

export function logInEpic(
  action$: ActionsObservable,
  state$: StateObservable,
  { Api }: Middleware
) {
  return action$.pipe(
    ofType(LOG_IN),
    mergeMap(() => {
      return Api.apiGet('kiosks/users/session').pipe(
        map(({ response }) => {
          return logInSuccess(response);
        }),
        catchError(error => {
          if (error?.message === '401') {
            SlingStorage.setItem(STORAGE_GUID_FIELD, null);
            SlingStorage.setItem(STORAGE_TIME_FORMAT_FIELD, null);
            SlingStorage.setItem(STORAGE_SESSION_FIELD, null);

            const message = [
              'There was a problem with this kiosk session.',
              'Your mission, if you choose to accept it, is to create a new kiosk session.',
              'This message will self destruct in '
            ];

            return of(addErrorToast(message, 10000, true), scheduleRedirection(10000));
          }

          bugsnagClient.notify(error);
          return of(addErrorToast(error));
        })
      );
    })
  );
}

export function integrationLogInEpic(
  action$: ActionsObservable,
  state$: StateObservable,
  { Api }: Middleware
) {
  return action$.pipe(
    ofType(INTEGRATION_LOG_IN),
    mergeMap(action => {
      const { orgId, staffId, origin, nonce, usTimeFormat, kioskSessionId } = action.payload;
      return Api.apiPost(
        `kiosks/sessions/initialize/${origin}`,
        {},
        { orgId, staffId, nonce },
        {},
        false
      ).pipe(
        mergeMap(({ response }) => {
          const { guid } = response.session.kiosk_session;
          return of(
            initializeSuccess(((guid: any): string), Boolean(usTimeFormat), origin, kioskSessionId),
            logInExternalUser(staffId),
            logInSuccess(response.userSession)
          );
        }),
        catchError(error => {
          bugsnagClient.notify(error);
          return of(addErrorToast(error));
        })
      );
    })
  );
}

export default combineEpics(logInEpic, integrationLogInEpic);
